import { MouseEventHandler, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Form } from "reactstrap";
import LoginError from "./loginError";
import UserEmailInput from "./userEmailInput";
import { PasswordInput } from "components/input";
import StartForgotPassword from "./startForgotPassword";
import * as routes from "../../../routes";
import SsoLoginButton from "./ssoLoginButton";
import LoginButton from "./loginButton";
import '../css/loginForm.css';

const LoginForm = (
    props: {
        handleSubmit: Function,
        handleSsoLogin: MouseEventHandler<HTMLButtonElement>,
        isLoading: boolean,
        error: string,
    }
) => {
    const { routePrefix } = useParams();
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const isValid = () => {
        return email && email.trim() && password && password.trim();
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (isValid()) {
            props.handleSubmit(email, password);
        }
    }

    return (
        <Form onSubmit={handleSubmit} className="loginForm">
            <LoginError isLoading={props.isLoading} error={props.error} />
            <UserEmailInput handleChange={(e) => setEmail(e.target.value)} value={email} />
            <PasswordInput
                onChange={(e: any) => setPassword(e.target.value)}
                label="Password"
                name="password"
                placeholder="Password"
            />
            <StartForgotPassword isLoading={props.isLoading} handleForgotPassword={() => dispatch(routes.forgotPassword(routePrefix))} />
            <LoginButton
                isLoading={props.isLoading}
                disabled={props.isLoading}
                text={"Login"}
                loadingText="Logging in..."
                isValid={() => isValid()}
            />
            <SsoLoginButton isLoading={props.isLoading} handleSSOLogin={props.handleSsoLogin} />
        </Form>
    )

}

export default LoginForm;